/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GroupMemberOutputDto { 
    userId?: number;
    memberId?: string | null;
    memberName?: string | null;
    type?: string | null;
    phoneNumber?: string | null;
    emailId?: string | null;
    status?: string | null;
}

